import { ASSET_PREFIX } from 'utils/constants';

/** An array of team members, mainly for the about us page, but also used for employee count around the site */
export const teamMembers = [
  {
    image: `${ASSET_PREFIX}/images/about-us/andrew.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/andrew-travel.jpg`,
    name: 'Andrew',
    linkedInLink: 'https://www.linkedin.com/in/abroekelmann/',
    jobTitle: 'Co-founder & CEO',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/lisa.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/lisa-travel.jpg`,
    name: 'Lisa',
    linkedInLink: 'https://www.linkedin.com/in/lisanederveen/',
    jobTitle: 'Co-founder & COO',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/callum.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/callum-fun.jpg`,
    name: 'Callum',
    linkedInLink: 'https://www.linkedin.com/in/callum-wright-230a4574/',
    jobTitle: 'Co-founder & UX/UI Designer',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/violet.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/violet-travel.jpg`,
    name: 'Violet',
    linkedInLink: 'https://www.linkedin.com/in/violet-currey-302362a1/',
    jobTitle: 'Customer Success Manager',
  },

  {
    image: `${ASSET_PREFIX}/images/about-us/david.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/david-travel.jpg`,
    name: 'David',
    linkedInLink: 'https://www.linkedin.com/in/david-walby-b759902b/',
    jobTitle: 'Head of Growth',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/reshat.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/reshat-travel.jpg`,
    name: 'Reshat',
    linkedInLink: 'https://linkedin.com/in/re%C5%9Fat-serpek-6b9232182/',
    jobTitle: 'Full Stack Developer',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/tim.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/tim-travel.jpg`,
    name: 'Tim',
    linkedInLink: 'https://www.linkedin.com/in/timothy-lui/',
    jobTitle: 'CTO',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/kayne.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/kayne-travel.jpg`,
    name: 'Kayne',
    linkedInLink: 'https://www.linkedin.com/in/kayne-chung/',
    jobTitle: 'Backend Developer',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/jordan.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/jordan-travel.jpg`,
    name: 'Jordan',
    linkedInLink:
      'https://www.linkedin.com/in/jordan-johnston-teggart-537895216/',
    jobTitle: 'Customer Success Team Lead',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/heenal.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/heenal-travel.jpg`,
    name: 'Heenal',
    linkedInLink: 'https://www.linkedin.com/in/heenal-vaghela-069011238/',
    jobTitle: 'Customer Success Agent',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/jasmine.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/jasmine-travel.jpg`,
    name: 'Jasmine',
    linkedInLink: 'https://www.linkedin.com/in/jasminebaragwanath/',
    jobTitle: 'Social Media Manager',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/luca.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/luca-travel.jpg`,
    name: 'Luca',
    linkedInLink: 'https://www.linkedin.com/in/luca-tsouloulis-a83487174/',
    jobTitle: 'Graphic designer',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/alice.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/alice-travel.jpg`,
    name: 'Alice',
    linkedInLink: 'https://www.linkedin.com/in/alicemarshall-1/',
    jobTitle: 'Senior Full Stack Developer',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/steve.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/steve-travel.jpg`,
    name: 'Steve',
    linkedInLink: 'https://www.linkedin.com/in/steven-c-bb1756157/',
    jobTitle: 'Lead Developer',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/sakinah.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/sakinah-travel.jpg`,
    name: 'Sakinah',
    linkedInLink: 'https://linkedin.com/in/sakinahpryce',
    jobTitle: 'Customer Success Agent',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/gabriele.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/gabriele-travel.jpg`,
    name: 'Gabriele',
    linkedInLink: 'https://www.linkedin.com/in/gabrielecorà/',
    jobTitle: 'Winner Manager',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/hollie.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/hollie-travel.jpg`,
    name: 'Hollie',
    linkedInLink: 'https://www.linkedin.com/in/hollie-peterson-502275234',
    jobTitle: 'Customer Success Agent',
  },
  {
    image: `${ASSET_PREFIX}/images/about-us/emily.jpg`,
    funImage: `${ASSET_PREFIX}/images/about-us/emily-travel.jpg`,
    name: 'Emily',
    linkedInLink: 'https://www.linkedin.com/in/emily-henwood-marketing',
    jobTitle: 'CRM/Lifecycle Manager',
  },
];
export const teamMemberCount = teamMembers.length;